import _get from 'lodash/get';
import { PROFILE, FRONTSPACE, PROFILES_GATE, OPTOUT } from '@bedrock-rdk/constants';
import config from '@bedrock-rdk/config';
import { LAYOUT_ENTITIES } from '@bedrock/fido-sdk';
import { t } from '../../i18n/index';
import CTA from '../../cta/cta.constants';
import { getItemActionType } from '../../cta/cta.utils';
import { getPairingStatus } from '../../../logic/pairing/pairing.selectors';
import { getOpenCatalogFeature } from '../../../logic/features/features.selectors';
import { PAIRING_STATUS_PAIRED, REQUIRE_AUTH } from '../../../logic/pairing/pairing.constants';
import { getNavigationFeatures } from './customer/default/account.utils';
import { getPairingUid } from '../../../logic/user/user.selectors';

const REPLACEMENT_MAP = {
  account_consentmanagement: OPTOUT,
};

export const makeProfilesGateAction = () => ({
  item: {
    action: {
      target: {
        type: 'layout',
        value_layout: {
          type: FRONTSPACE,
          id: PROFILES_GATE,
        },
      },
      analytics: {
        key: 'pressSwitchProfileButton',
        googleAnalytics: {
          eventAction: 'menu_account',
          eventCategory: 'browsing',
          eventLabel: t('profile.switch'),
        },
        tealium: {
          event_action: 'menu_account',
          event_category: 'browsing',
          event_label: t('profile.switch'),
        },
      },
    },
  },
});

export const makeAuthLockAction = () => ({
  id: 'login',
  picto: { type: 'icon', name: 'Disconnected' },
  groups: [],
  label: t('user.login'),
  target: {
    type: 'lock',
    value_lock: {
      reason: REQUIRE_AUTH,
      originalTarget: {
        type: 'layout',
        value_layout: {
          type: LAYOUT_ENTITIES.alias,
          id: 'home',
        },
      },
    },
  },
});

export const mapProfileUnpairedLocks = item => item;

export const getProfileEntriesFilter = state => {
  const profileNavigationFeatures = getNavigationFeatures(state);

  return entry => profileNavigationFeatures[entry.id] !== false;
};

export const mapProfileEntries = (item, state) => {
  const profileEntriesFilter = getProfileEntriesFilter(state);

  return _get(item, 'subEntries', []).filter(profileEntriesFilter);
};

/**
 * In case backend couldn't unlock something for paired used, removing those locks
 *
 * @param {Object} item navigation entry
 * @returns {Object}
 */
export const mapProfileLocks = item => {
  const isLockAction = _get(item, 'target.type', '') === CTA.LOCK;
  const isReasonRequireAuth = _get(item, 'target.value_lock.reason', '') === REQUIRE_AUTH;
  const originalTarget = _get(item, 'target.value_lock.originalTarget', null);
  item.target = isLockAction && isReasonRequireAuth && originalTarget ? originalTarget : item.target;

  return item;
};

export const getMapProfileLocks = state => {
  const isUserPaired = getPairingStatus(state) === PAIRING_STATUS_PAIRED;

  return isUserPaired ? mapProfileLocks : mapProfileUnpairedLocks;
};

export const isActionSupported = entry =>
  config.cta.supportedActions.some(actionType => actionType === getItemActionType({ action: entry }));

export const getExtraItem = state => {
  if (!getOpenCatalogFeature(state) || getPairingUid(state)) {
    return [];
  }

  return [makeAuthLockAction()];
};

export const filterNavigationEntries = (value, state) => {
  const result =
    value &&
    value.entries &&
    value.entries.flatMap(entry => entry).find(item => getItemActionType(item.entry) === PROFILE);

  if (!_get(result, 'subEntries.length')) {
    return null;
  }

  return mapProfileEntries(result, state)
    .map(getMapProfileLocks(state))
    .map(item => {
      if (!item.target || !item.target.type) {
        return item;
      }

      const action = item.target[`value_${item.target.type}`];
      if (action) {
        action.reference = REPLACEMENT_MAP[action.reference] || action.reference;
      }

      return item;
    })
    .filter(isActionSupported)
    .concat(...getExtraItem(state));
};
